export default {
    ['app.mobileidworks.com']: 'janus_logo.png',
    ['iona.mobileidworks.com']: 'janus_logo.png',
    ['localhost']: 'janus_logo.png'
};